import KEY_CODES from '../../constants/keyCodes';

export default (editor, event) => {
  if (!editor.value.selection.isExpanded && event.which === KEY_CODES.DELETE)
    editor.moveToStartOfNextBlock();
  const { anchorBlock, document, focusBlock, selection } = editor.value;
  const { isForward } = selection;
  const lowerBlock = isForward ? focusBlock : anchorBlock;
  const parentListItem = document.getParent(lowerBlock.key);
  const childUlToBeMoved = parentListItem.nodes.toArray()[1];
  const grandParentUL = document.getParent(parentListItem.key);
  let sizeOfgrandParentUL = grandParentUL.nodes.toArray().length;
  const indexOfparentListItem = grandParentUL.nodes
    .toArray()
    .indexOf(parentListItem);
  const siblingsToBeMoved = grandParentUL.nodes
    .toArray()
    .slice(indexOfparentListItem + 1, sizeOfgrandParentUL);
  editor.deleteBackward();
  if (event.which === KEY_CODES.ENTER) editor.insertText('\n');
  const newParentListItem = editor.value.document.getParent(
    editor.value.focusBlock.key,
  );
  const newGrandParentListItem = editor.value.document.getParent(
    newParentListItem.key,
  );
  if (
    childUlToBeMoved !== undefined &&
    childUlToBeMoved.type === 'unordered_list'
  ) {
    editor.moveNodeByKey(childUlToBeMoved.key, newParentListItem.key, 1);
  }
  if (
    childUlToBeMoved !== undefined &&
    siblingsToBeMoved.length !== 0 &&
    siblingsToBeMoved[0].type === 'list_item'
  ) {
    siblingsToBeMoved.forEach((element) => {
      editor.moveNodeByKey(
        element.key,
        newGrandParentListItem.key,
        sizeOfgrandParentUL,
      );
      sizeOfgrandParentUL = +1;
    });
  }
  return true;
};
